// ErrorBoundary.js
import React, { createContext, useRef, useContext } from 'react';

const ErrorBoundaryContext = createContext(null);
const baseErrorMessage = 'Could not load shopping cart. Please contact administrator';
const baseUnhandledErrorMessage = 'An error occured. Please contact administrator';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error(baseErrorMessage);
  }

  handleError = (errorMessage) => {
    alert(errorMessage ?? baseErrorMessage);
    this.setState({ hasError: true, error: new Error(errorMessage) });
  };

  render() {
    return this.props.children;
  }
}

const ErrorBoundaryProvider = ({ children }) => {
  const errorBoundaryRef = useRef(null);

  const handleError = (errorMessage) => {
    errorBoundaryRef.current?.handleError(errorMessage);
  };

  // React.useEffect(() => {
  //   const handleGlobalError = (message, source, lineno, colno, error) => {
  //     console.log("error", error);
  //     handleError(baseUnhandledErrorMessage);
  //     console.error = () => {};
  //     return true;
  //   };

  //   const handlePromiseRejection = (event) => {
  //     event.preventDefault();
  //     handleError(baseUnhandledErrorMessage);
  //   };

  //   window.onerror = handleGlobalError;
  //   window.onunhandledrejection = handlePromiseRejection;

  //   return () => {
  //     window.onerror = null;
  //     window.onunhandledrejection = null;
  //   };
  // }, []);

  return (
    <ErrorBoundaryContext.Provider value={handleError}>
      <ErrorBoundary ref={errorBoundaryRef}>
        {children}
      </ErrorBoundary>
    </ErrorBoundaryContext.Provider>
  );
};


const useErrorBoundary = () => {
  const handleError = useContext(ErrorBoundaryContext);
  if (!handleError) {
    throw new Error(baseErrorMessage);
  }
  return handleError;
};

export { ErrorBoundaryProvider, useErrorBoundary, ErrorBoundary };